import { Component, OnInit, Inject, ViewChild, DOCUMENT, ChangeDetectionStrategy, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { isPlatformBrowser, Location } from '@angular/common';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { Subscription } from 'rxjs';
import { AppService } from './services/app/app.service';
import { EventsService } from './services/events/events.service';
import { RestService } from './services/rest/rest.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Utils } from './components/utils/Utils';
import { Log } from './core/logging/log';
import { environment } from 'environments/environment';
import { ParameterCart } from './models/cart-model';
import { ConfigService } from './services/config/config.service';
import { ConfigGlobalModel } from './models/config-global-model';
import { LanguageService } from './services/language/language.service';
import { isSupportedLanguage } from './services/language/languages';
import { SeoService } from './services/seo/seo.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
    private _router: Subscription;
    @ViewChild(NavbarComponent) navbar: NavbarComponent;
    

    constructor(public appService: AppService,
        private restService: RestService,
        private eventsService: EventsService,
        private configService: ConfigService,
        private language: LanguageService,
        private seo: SeoService,
        private gtmService: GoogleTagManagerService,
        private router: Router, 
        private route: ActivatedRoute,
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: object,
        public location: Location
        ) {}

        
    ngOnInit() {

        let config:ConfigGlobalModel = this.configService.settings;
        this.setPrimaryColor(config.color);
        this.appService.kiosk = config.name;

        if (isPlatformBrowser(this.platformId)) {
            this.route.queryParams.subscribe(params => {
                let update:boolean = false;
                let parameters:ParameterCart = Utils.getParams(this.route.snapshot.queryParamMap);

                Log.debug('params', {params});
               // if(params!=null && params['tenant_id'] != null){
                //    let tenantId = params['tenant_id'];
               //     this.appService.tenantId = tenantId;
               // }

                if(params!=null && params['commissionAgentId'] != null){
                    parameters.commissionAgentId = params['commissionAgentId'];
                    update = true;
                }

                if(params != null && params['discountCode'] != null){
                    parameters.userData.discountCode = params['discountCode'];
                    update = true;
                }

                if(update){
                    this.router.navigate([], {
                        relativeTo: this.route,
                        queryParams: Utils.generateParams(parameters),
                        // queryParamsHandling: 'merge'
                    });
                }
            });
        }

        this.appService.setMeta(
            this.appService.getTraduccion('meta.title'), 
            this.appService.getTraduccion('meta.description')
        );
        this.updateFavicon();
        this.setLangHtml();
        this.seo.updateRoute(this.router.url);

        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        this.router.events.subscribe(event => {
            if(event instanceof NavigationEnd) {
                this.language.syncFromUrl(event.urlAfterRedirects);
                this.setLangHtml();
                this.seo.updateRoute(event.urlAfterRedirects);
            }
            // NavigationEnd
            // NavigationCancel
            // NavigationError
            // RoutesRecognized
        });
        this.getProfile();
 
        this.router.events.forEach(item => {
            if (item instanceof NavigationEnd) {
              const gtmTag = {
                event: 'page',
                pageName: item.url
              };
              Log.debug("google tagmanager")
              this.gtmService.pushTag(gtmTag);
            }
          });

    }

    ngOnDestroy(): void {

	}

    private updateFavicon(): void {
        const faviconUrl = this.configService.settings?.logo?.imageSmall
            || this.configService.settings?.logo?.imageMedium
            || this.configService.settings?.logo?.imageLarge;

        if (!faviconUrl) {
            return;
        }

        this.upsertLinkTag('app-favicon-32', 'icon', faviconUrl, 'image/png', '32x32');
        this.upsertLinkTag('app-favicon-16', 'icon', faviconUrl, 'image/png', '16x16');
        this.upsertLinkTag('app-apple-touch-icon', 'apple-touch-icon', faviconUrl);
    }

    private upsertLinkTag(
        id: string,
        rel: string,
        href: string,
        type?: string,
        sizes?: string
    ): void {
        let linkElement = this.document.getElementById(id) as HTMLLinkElement | null;

        if (!linkElement) {
            linkElement = this.document.createElement('link');
            linkElement.id = id;
            linkElement.rel = rel;
            this.document.head.appendChild(linkElement);
        }

        linkElement.href = href;

        if (type) {
            linkElement.type = type;
        }

        if (sizes) {
            linkElement.setAttribute('sizes', sizes);
        } else {
            linkElement.removeAttribute('sizes');
        }
    }

    setPrimaryColor(color: string) {
        this.document.documentElement.style.setProperty('--color-primary', color);
    }

    setLangHtml() {
        let canonical:any = this.document.querySelector('html');
        if (canonical !== null) {
            canonical.lang = this.language.currentLang;
        }
    }

    /*
    get showTenantAs():boolean {
        return !environment.production;
    }*/

    showLoginAs():boolean {
        return this.appService.isAdmin() || this.appService.isImpersonating();
    }

    showHeader() {
        return true;
        
        var titlee = this.location.prepareExternalUrl(this.location.path());
        let found = titlee.split('/').find(f=>f=='reserve')!=undefined;
        if(found){
            return true;
        }else{
            return false;
        }
    }

    showFooter() {
        const segments = this.router.url.split(/[?#]/, 1)[0].split('/').filter(Boolean);
        return (segments.length === 1 && isSupportedLanguage(segments[0]))
        || /^\/[^/]+\/(?:legal-notice|privacy-policy|terms-service|cookie-policy)(?:[?#]|$)/.test(this.router.url)
        || this.router.url.includes('locker-location')
        || this.router.url.includes('locker-type') 
        || this.router.url.includes('reserves') 
        || this.router.url.includes('visor') 
        || this.router.url.includes('my-wallet')
        || this.router.url.includes('my-commissions')
        || this.router.url.includes('change-password');
    }

    getProfile(){
        if(!AppService.isToken()){
            Log.debug('Token not exist');
            return;
        }
        this.restService.getProfile().subscribe(result => {
          Log.debug('getProfile', {result});
          if(result.id !=null && result.id != 0){
            AppService.autenticado = true;
            this.appService.usuario = result;
            this.eventsService.publish('getProfile', result);
            this.appService.setCurrentUser(result);
          }
        },
          error => {
            Log.error('error', {error});
            Log.error('error', {status: error.status});
            if(error.status == 401){
                AppService.autenticado = false;
                AppService.clearToken();
            }
          }
        );
      }

}
